import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useMultiStyleConfig} from '@chakra-ui/react'
//import RecentSearches from './recent-searches'
import Suggestions from './suggestions'

//const SearchSuggestions = ({recentSearches, searchSuggestions, closeAndNavigate}) => {
const SearchSuggestions = ({searchSuggestions, closeAndNavigate, onSuggestedCategorySubmit}) => {
    const styles = useMultiStyleConfig('Search', {variant: 'modalSearch'})
    const useSuggestions = searchSuggestions && searchSuggestions?.length > 0
    return (
        useSuggestions && (
            <Flex {...styles.searchSuggestions}>
                <Suggestions
                    closeAndNavigate={closeAndNavigate}
                    suggestions={searchSuggestions}
                    onSuggestedCategorySubmit={onSuggestedCategorySubmit}
                />
                {/* <RecentSearches
                    recentSearches={recentSearches}
                    closeAndNavigate={closeAndNavigate}
                    /> */}
            </Flex>
        )
    )
}

SearchSuggestions.propTypes = {
    recentSearches: PropTypes.array,
    searchSuggestions: PropTypes.array,
    closeAndNavigate: PropTypes.func,
    onSuggestedCategorySubmit: PropTypes.func,
}

export default SearchSuggestions
